import { computed, readonly } from 'vue'
import { authUser } from './authState.js'

/**
 * Centralized composable for accessing the current user from in-memory auth
 * state. The server-side session cookie remains inaccessible to JavaScript.
 */
export function useCurrentUser() {
  const name = computed(() => authUser.value?.name || '')
  const email = computed(() => authUser.value?.email || '')
  const picture = computed(() => authUser.value?.picture || null)
  const isLoggedIn = computed(() => !!authUser.value)

  function setUserInfo(info) {
    authUser.value = info
  }

  function clearUserInfo() {
    authUser.value = null
  }

  function getApiUserInfo() {
    return {
      name: name.value,
      email: email.value
    }
  }

  function refresh() {
    // Auth state is updated centrally by useAuth().initAuth().
  }

  return {
    user: readonly(authUser),
    name,
    email,
    picture,
    isLoggedIn,
    setUserInfo,
    clearUserInfo,
    getApiUserInfo,
    refresh
  }
}

// Export singleton helpers for direct use.
export const currentUser = {
  get name() {
    return authUser.value?.name || ''
  },
  get email() {
    return authUser.value?.email || ''
  },
  getApiUserInfo() {
    return {
      name: authUser.value?.name || '',
      email: authUser.value?.email || ''
    }
  }
}
